export const HAS_IDB = typeof window !== 'undefined' && typeof window.indexedDB !== 'undefined';
/**
 * Async check that verifies IndexedDB can actually be opened. `HAS_IDB` only
 * checks that the API object exists; it does not catch failures from corrupted
 * storage, strict-privacy mode, or full disk. This promise resolves to `true`
 * only after a real `indexedDB.open()` round-trip succeeds.
 */
export const IDB_WORKS = (async () => {
    if (!HAS_IDB)
        return false;
    try {
        const testName = '__idb_health_check__';
        const req = indexedDB.open(testName);
        await new Promise((resolve, reject) => {
            req.onerror = () => reject(req.error);
            req.onblocked = () => reject(new Error('IDB health check blocked'));
            req.onsuccess = () => {
                req.result.close();
                resolve();
            };
        });
        // Clean up the probe database so it doesn't linger
        indexedDB.deleteDatabase(testName);
        return true;
    }
    catch (error) {
        // console.error is used instead of logger because common/ cannot import
        // logger/ (circular dependency). Datadog RUM still captures console.error.
        console.error('[IDB Health Check] IndexedDB is unexpectedly not available', error);
        return false;
    }
})();
//# sourceMappingURL=indexedDB.js.map